import React from 'react';
import { i18n } from '@international/mastodon-i18n';
import { PromptGroup, PromptDocuments } from 'types/candidateStories';
import { findItemTranslation, getPromptItemById } from './promptGroupHelpers';
import DocumentList from '../../../fields/DocumentList';

const PromptSummaryFileList = ({
  documents,
  promptGroups,
  recordId,
}: {
  documents: PromptDocuments;
  promptGroups: PromptGroup[];
  recordId?: string;
}) => {
  const currentLanguage = i18n.getLocale();

  if (!documents || Object.keys(documents).length === 0) {
    return null;
  }

  return (
    <div
      data-testid={
        recordId
          ? `prompt-summary-file-list-${recordId}`
          : 'prompt-summary-file-list'
      }
    >
      {Object.entries(documents).map(
        ([promptItemId, { documents: promptDocuments }]) => {
          if (!promptDocuments || promptDocuments.length === 0) {
            return null;
          }

          const promptItem = getPromptItemById(promptGroups, promptItemId);
          const translatedItem = findItemTranslation(
            promptItem,
            currentLanguage,
          );

          return (
            <div key={promptItemId} className='mb-3'>
              <h6 className='mb-2'>{translatedItem?.title}</h6>
              <div className='cans-doc-wrapper'>
                <DocumentList
                  documents={promptDocuments}
                  allowDocumentRemoval={false}
                />
              </div>
            </div>
          );
        },
      )}
    </div>
  );
};

export default PromptSummaryFileList;
